// @ts-nocheck
/**
 * Glass-iOS toggle for the agent's "Include cell references" affordance.
 *
 * Visual + interaction language ports the dock-mode dark-mode switch from
 * AccountOverview (see ios-theme-switch in AccountOverview.css). Kept as
 * its own component so the dock-mode markup stays single-purpose; the
 * styles live in CellReferencesToggle.css with their own .cell-ref-toggle-*
 * prefix so we never accidentally have a single rule fighting two
 * semantically different switches.
 *
 * Animation: CSS-only @keyframes mount + cubic-bezier knob slide. Framer
 * Motion was tempting but the prior FinalMappingCard mount animation hit
 * a hydration-invisibility bug — see the comment on its <div className="fmc-card">
 * — so the rule of thumb here is to avoid library-driven mount animation
 * on the final card and anything that hangs off it.
 */
import React from 'react';
import { Link2 } from 'lucide-react';

import './CellReferencesToggle.css';

interface CellReferencesToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  hint?: string;
}

export function CellReferencesToggle({
  checked,
  onChange,
  disabled = false,
  label = 'Include cell references',
  hint,
}: CellReferencesToggleProps) {
  const onClickTrack = () => {
    if (!disabled) onChange(!checked);
  };

  return (
    <label
      className={`cell-ref-toggle ${checked ? 'is-on' : ''} ${
        disabled ? 'is-disabled' : ''
      }`}
      title={hint}
    >
      <Link2 size={14} className="cell-ref-toggle-icon" aria-hidden="true" />
      <span className="cell-ref-toggle-label">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={onClickTrack}
        disabled={disabled}
        className="cell-ref-toggle-track"
      >
        <span className="cell-ref-toggle-knob" />
      </button>
    </label>
  );
}

export default CellReferencesToggle;
